
import DefaultProfile from '@src/components/common/defaultProfile';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Box, Button, Flex } from 'theme-ui';

const bookALesson = ({ onNext, vm, onSubmit, addToCart }) => {
  const { t } = useTranslation();

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        height: '100%',
        maxWidth: '450px',
        margin: 'auto',
      }}
    >
      <Flex pb={5} sx={{ fontSize: '20px', gap: '28px' }}>
        <Box
          sx={{
            flexShrink: 0,
            position: 'relative',
            size: '90px',
            overflow: 'hidden',
            borderRadius: '50%',
          }}
        >
          <DefaultProfile size="90px" />

          {vm.image && (
            <GatsbyImage
              sx={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
              image={vm.image}
              alt=""
            />
          )}
        </Box>

        <Box sx={{ flexShrink: 1 }}>
          <Box pb={3} className="lesson-teacher" sx={{ lineHeight: 1.2 }}>
            <div>{vm.productTitle}</div>
          </Box>
          <Box className="lesson-time" sx={{ lineHeight: 1.2 }}>
            <Box sx={{ color: 'grey600' }}>{t('creator')}</Box>
            <Box sx={{ color: 'grey600' }}>{vm.author}</Box>
          </Box>
        </Box>
      </Flex>

      <Flex
        sx={{ marginTop: 'auto', gap: '20px' }}
        className="book-a-lesson__footer"
      >
        <Button
          sx={{ flex: 1 }}
          variant="inverted"
          type="button"
          onClick={addToCart}
        >
          {t('addToCart')}
        </Button>
        <Button onClick={onNext} type="button" sx={{ flex: 1 }}>
          {t('pay')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default bookALesson;
